import React, { useContext, useState, useEffect } from "react"
import { auth } from "../firebase"
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  query, where,doc,updateDoc
} from "firebase/firestore";
import { useHistory } from "react-router-dom";
import {updatePassword } from "firebase/auth";

const AuthContext = React.createContext()
// const delay = ms => new Promise(res => setTimeout(res, ms));
export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const history = useHistory();
  const [currentUser, setCurrentUser] = useState()
  const [loading, setLoading] = useState(true)
  const usersCollectionRef = collection(db, "Users");
  const recordsCollectionRef = collection(db, "Records");
  const usersContributionRef = collection(db, "Contributions");
  const userInterestGainRef = collection(db, "InterestsGained")
  const monthlySRRef = collection(db, "monthlySR")
  const incomeExpenseRef = collection(db, "Records");
  const srRef = collection(db, "SR");
  const [role, setRole] = useState();
  const [currentRole, setCurrentRole] = useState();
  const [currentGenFund, setCurrentGenFund] = useState();
  const [currentEduFund, setCurrentEduFund] = useState();
  const [currentOptFund, setCurrentOptFund] = useState();
  const [currentDevFund, setCurrentDevFund] = useState();
  const [currentPatronage, setCurrentPatronage] = useState();
  const [currentISC, setCurrentISC] = useState();
  const [currentStatus, setCurrentStatus] = useState();
  const [contribution, setContribution] = useState(0);
  const [coopContributions, setCoopContributions] = useState([]);
  const [incomeExpense, setIncomeExpense] = useState([]);
  const [interestGain, setInterestGain] = useState([]);

  function signup(email, password, firstname , middlename , lastname , birthdate , fulladdress , dependent1 , dependent2, dependent3) {
   return (auth.createUserWithEmailAndPassword(email, password).then(()=>{signupDB(email, password, firstname , middlename , lastname , birthdate , fulladdress , dependent1 , dependent2, dependent3)}))
  }

  async function getIncomeExpense(){
    const q = collection(db, "Records");
    const querySnapshot = await getDocs(q);
    setIncomeExpense(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

  };

  async function getInterestGain(){
    const q = collection(db, "InterestsGained");
    const querySnapshot = await getDocs(q);
    setInterestGain(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

  };
 


  function signupDB(email, password, firstname , middlename , lastname , birthdate , fulladdress , dependent1 , dependent2, dependent3) {
    let today = new Date();  // get the date
      let day = ("0" + today.getDate()).slice(-2);  //get day with slice to have double digit day
      let month = ("0" + (today.getMonth() + 1)).slice(-2); //get your zero in front of single month digits so you have 2 digit months
      let date = month + '/' + day + '/' + today.getFullYear(); 
    return (
      
      addDoc(usersCollectionRef, { 
        EmailAddress: email, 
        Role: "Member", 
        Status: "Pending", 
        FirstName: firstname, 
        MiddleName: middlename,
        LastName: lastname, 
        Birthdate: birthdate, 
        FullAddress: fulladdress, 
        Dependent1: dependent1, 
        Dependent2: dependent2, 
        Dependent3: dependent3, 
        DateRegistered: date,
        DisplayImage: 'Default.jpg'
      })
      
      
    )
  }
  function createRecord(Type,Amount, Date, Description) {
    
    return (
      addDoc(recordsCollectionRef, {
        Type: Type,
        Amount : Amount, 
        Description:Description, 
        "Date of Use":Date
      })
      
    )
  }

  const updateUserStatus = async (id, val) => {
    const userDoc = doc(db, "Users", id);
    const newFields = { Status : val};
    return(
    await updateDoc(userDoc, newFields)
    )
  };
  const updateSR = async (genFund,eduFund,optFund,devFund,patronage,isc) => 
  {
    const srDoc = doc(db, "SR", "ATSCSR");
    const newFields = { "General Reserve Fund" : genFund, "Education & Training Fund": eduFund, "Optional Fund": optFund, "Community Development Fund": devFund, "Patronage":patronage, "ISC":isc};
    return(
    await updateDoc(srDoc, newFields)
    )
  }

  const updateUserRole = async (id, val) => {
    const userDoc = doc(db, "Users", id);
    const newFields = { Role : val};
    await updateDoc(userDoc, newFields);
  };
  
  function addContribution(contributor, amount) {
    let today = new Date();  // get the date
      let day = ("0" + today.getDate()).slice(-2);  //get day with slice to have double digit day
      let month = ("0" + (today.getMonth() + 1)).slice(-2); //get your zero in front of single month digits so you have 2 digit months
      let date = month + '/' + day + '/' + today.getFullYear();   
    return (
      
      addDoc(usersContributionRef, { ContributorID: contributor, Amount: amount, date, Status: "Pending"})
      
    )
  }

  function recordInterestGain(contributor, amount , date) {  
    return (
      
      addDoc(userInterestGainRef, { ContributorID: contributor, Amount: amount, Date: date})
      
    )
  }
  function recordMonthlySR(generalAmount, optionalAmount , educationAmount, communityAmount, date) {  
    return (
      
      addDoc(monthlySRRef, { 'General Reserve Fund': generalAmount, 'Education & Training Fund': educationAmount, 'Community Development Fund': communityAmount, 'Optional Fund': optionalAmount, Date: date})
      
    )
  }

  async function updateInfo(id,firstName, lastName, middleName, birthDate, address, dependent1, dependent2, dependent3) {
    const userDoc = doc(db, "Users", id);
    const newFields = {
      FirstName: firstName,
        LastName:lastName,
        MiddleName:middleName,
        BirthDate:birthDate,
        FullAddress:address,
        Dependent1:dependent1,
        Dependent2:dependent2,
        Dependent3:dependent3
    };
    
    return (
      await updateDoc(userDoc, newFields)
    )
  }
 
  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password)
  }

  function logout() {
    
    return auth.signOut()
    
  }
  function whereToGo(){
    if(currentStatus === "Pending")
      {
        return history.push("/accountonhold")
      }
      if(currentStatus === "Active")
      {
        return history.push("/userdashboard")
      }
  }
  async function resetPassword(email) {
    var emailAddress = email;
    auth.sendPasswordResetEmail(emailAddress)
    .then(function() {  
    // Email sent.
    })
    .catch(function(error) {
    // An error happened.
    });
  }
  function updateEmail(email) {
    return currentUser.updateEmail(email)
  }

  function updatePassword(currentPassword) {
    const user = auth.currentUser;
    return user.updatePassword(currentPassword)
  }

  async function getUser(email){
    const q = query(collection(db, "Users"), where("EmailAddress", "==", email));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      setRole(doc.data().Role);
      setCurrentStatus(doc.data().Status);
    });;
  }
  async function getFund(){
    // const q = query(collection(db, "SR"), where("id", "==", "ATSCSR"));
    const querySnapshot = await getDocs(srRef);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      setCurrentEduFund(doc.data()['Education & Training Fund']);
      setCurrentOptFund(doc.data()['Optional Fund']);
      setCurrentDevFund(doc.data()['Community Development Fund']);
      setCurrentGenFund(doc.data()['General Reserve Fund']);
      setCurrentPatronage(doc.data()['Patronage']);
      setCurrentISC(doc.data()['ISC']);
      // console.log(doc.data()['General Reserve Fund']);
    });;
  }
  
  // async function getContribution(email){
  //   const q = query(collection(db, "Contributions"), where("EmailAddress", "==", email));
  //   const querySnapshot = await getDocs(q);
  //   querySnapshot.forEach((doc) => {
  //     // doc.data() is never undefined for query doc snapshots
  //     setRole(doc.data().Role);
  //     setCurrentStatus(doc.data().Status);
  //   });;
  // }

  async function getUserContribution(id){
    const q = query(collection(db, "Contributions"), where("ContributorID", "==", id));
    const querySnapshot = await getDocs(q);
    let total = 0
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      total = total + Number(doc.data().Amount)   
    });;
    setContribution(total)
  }
  async function getContributions(){
    const q = collection(db, "Contributions");
    const querySnapshot = await getDocs(q);
    setCoopContributions(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  }
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentRole(role)
      setCurrentUser(user)
      setLoading(false)
      // setRole(users.find( user1 => user1.EmailAddress.toString() === user.email))

    })

    return unsubscribe
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  })
  
  

  const value = {
    currentUser,
    currentRole,
    currentStatus,
    contribution,
    currentGenFund,
    currentEduFund,
    currentOptFund,
    currentDevFund,
    currentPatronage,
    currentISC,
    coopContributions,
    incomeExpense,
    interestGain,
    login,
    signup,
    logout,
    updateEmail,
    updatePassword,
    updateInfo,
    getUser,
    addContribution,
    getUserContribution,
    updateUserStatus,
    updateUserRole,
    createRecord,
    updateSR,
    getFund,
    getContributions,
    getIncomeExpense,
    recordInterestGain,
    getInterestGain,
    recordMonthlySR,
    whereToGo,
    resetPassword
  }

  



  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
